export enum FocusSelectorTriggerSource {
    OBSERVATION,
    COMMITMENT,
    MANAGE_GOALS,
}
